import React from 'react';
import {forEach} from 'lodash';

import ProjectScope from "./../projectScope/projectScope";
import * as Misc from './../../misc';

export default ({handleEditQuoteClick}) => {
  const quotes = ProjectScope.quotes();
  let grantTotal = 0;
  forEach(quotes, function (q) {
    grantTotal += q.totalPrice;
  });

  return (
    <div className="review-submit-total-wrapper" key="totals">
      <div className="review-submit-total-wrapper-cell">
        <div className="review-submit-total-wrapper-edit" onClick={e => Misc.ignore(e, () => handleEditQuoteClick())}>Edit quote</div>
      </div>
      <div className="review-submit-total-wrapper-cell">
        <div className="review-submit-total-boxes review-submit-total-left-settings">
          <div className="review-submit-total-boxes-cart"></div>
          <h8>Grand Total</h8>
          <h9>${grantTotal.toFixed(2) }</h9>
        </div>
      </div>
      <div className="review-submit-total-wrapper-cell">
        <div className="review-submit-total-boxes review-submit-total-right-settings">
          <h8>Subtotal</h8>
          <h9>${ProjectScope.quote().totalPrice.toFixed(2) }</h9>
        </div>
      </div>
    </div>
  );

};



// WEBPACK FOOTER //
// ./src/components/projectSummary/totals.js